module.exports = __webpack_public_path__ + "static/media/HybridBarley_Green.3d8d7d70.svg";